import React, { createContext, useContext, useState } from "react";

export interface SubSubMenu {
  subSubMenuId: string;
  subMenuId: string;
  title: string;
  route: string;
  permissions?: string;
}

export interface UserSubMenu {
  submenuId: string;
  menuId: string;
  title: string;
  route: string;
  permissions?: string;
  subSubmenus?: SubSubMenu[];
}

export interface UserMenu {
  menuId: string;
  menu_title: string;
  menu_route: string;
  permissions?: string;
  submenus?: UserSubMenu[];
}

export const PermissionContext = createContext<any>(null);

export const PermissionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [permissionsMap, setPermissionsMap] = useState({});
  const [menus, setMenus] = useState<UserMenu[]>([]);

  const setPermissionsFromMenu = (menuList: any[]) => {
    const permissionObj: Record<string, string[]> = {};

    menuList.forEach((menu) => {
      // Main menu permissions
      if (menu.menu_route && menu.permissions) {
        permissionObj[menu.menu_route] =
          menu.permissions
            .split(",")
            .map((permission: string) => permission.trim());
      }

      // Submenu permissions
      menu.submenus?.forEach((submenu: any) => {
        if (submenu.route && submenu.permissions) {
          permissionObj[submenu.route] =
            submenu.permissions
              .split(",")
              .map((permission: string) => permission.trim());
        }

        // Sub-submenu permissions
        submenu.subSubmenus?.forEach((subSubmenu: any) => {
          if (
            subSubmenu.route &&
            subSubmenu.permissions
          ) {
            permissionObj[subSubmenu.route] =
              subSubmenu.permissions
                .split(",")
                .map((permission: string) =>
                  permission.trim()
                );
          }
        });
      });
    });

    setPermissionsMap(permissionObj);
  };

  const setMenusFromMenu = (userMenusResponse: UserMenu[]) => {
    setMenus(Array.isArray(userMenusResponse) ? userMenusResponse : []);
  };

  // const getSubSubMenus = (submenuRoute: string): SubSubMenu[] => {
  //   const submenu = menus
  //     .flatMap((menu) => menu.submenus || [])
  //     .find((item) => item.route === submenuRoute);

  //   return submenu?.subSubmenus || [];
  // };

  const getSubSubMenus = (submenuTitle: string): SubSubMenu[] => {
    const submenu = menus
      .flatMap((menu) => menu.submenus || [])
      .find(
        (item) => item.title?.trim().toLowerCase() === submenuTitle.trim().toLowerCase()
      );

    return submenu?.subSubmenus || [];
  };

  return (
    <PermissionContext.Provider
      value={{
        permissionsMap,
        setPermissionsFromMenu,
        menus,
        setMenusFromMenu,
        getSubSubMenus,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);